import {
  FETCH_DOC_VERIFY_FAILURE,
  FETCH_DOC_VERIFY_REQUEST,
  FETCH_DOC_VERIFY_SUCCESS,
} from 'constants/documents';
import type { DocVerifyResult } from 'services/payex/payments/types';

export type DocVerifyResultEntry = { fileId: string } & DocVerifyResult;

export type DocVerifyResultsState = Record<string, DocVerifyResultEntry>;

type DocVerifyAction =
  | {
      type: typeof FETCH_DOC_VERIFY_REQUEST;
      payload: { fileId: string };
    }
  | {
      type: typeof FETCH_DOC_VERIFY_SUCCESS;
      payload: { fileId: string } & DocVerifyResult;
    }
  | {
      type: typeof FETCH_DOC_VERIFY_FAILURE;
      payload: { fileId: string };
    };

const docVerifyResults = (
  state: DocVerifyResultsState = {},
  action: DocVerifyAction,
): DocVerifyResultsState => {
  switch (action.type) {
    case FETCH_DOC_VERIFY_SUCCESS:
      return { ...state, [action.payload.fileId]: action.payload };
    default:
      return state;
  }
};

export { docVerifyResults };
